<template>
  <div class="menu-main">
    <div classagnostics class="logo-box">
      <img src="../assets/img/logo.png" class="logo-img" />
      <img src="../assets/img/logobai.png" class="logo-img2" />
    </div>
    <div class="menu-box">
      <ul class="menu-list">
        <li>
          <a class="menu-item" @click="goToPage('HomePage')">{{
            $t("home")
          }}</a>
        </li>
        <li
          @click="toggleSubmenu('solutions')"
          :class="{ 'has-sub-menu': showSubmenu === 'solutions' }"
        >
          <a class="menu-item"
            >{{ $t("solutions") }}<i class="iconfont icon-xiala"></i
          ></a>
          <ul v-if="showSubmenu === 'solutions'" class="sub-menu">
            <li>
              <a class="sub-menu-item" @click="goToPage('SolutionPage1')">{{
                $t("solutionssub1")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('SolutionPage2')">{{
                $t("solutionssub2")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('SolutionPage3')">{{
                $t("solutionssub3")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('SolutionPage4')">{{
                $t("solutionssub4")
              }}</a>
            </li>
          </ul>
        </li>
        <li
          @click="toggleSubmenu('products')"
          :class="{ 'has-sub-menu': showSubmenu === 'products' }"
        >
          <a class="menu-item"
            >{{ $t("products") }}<i class="iconfont icon-xiala"></i
          ></a>
          <ul v-if="showSubmenu === 'products'" class="sub-menu">
            <li>
              <a class="sub-menu-item" @click="goToPage('ProductPage1')">{{
                $t("productssub1")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('ProductPage2')">{{
                $t("productssub2")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('ProductPage3')">{{
                $t("productssub3")
              }}</a>
            </li>
          </ul>
        </li>
        <li>
          <a class="menu-item" @click="goToPage('SupportPage')">{{
            $t("support")
          }}</a>
        </li>
        <li>
          <a class="menu-item" @click="goToPage('NewsPage')">{{
            $t("news")
          }}</a>
        </li>
        <li>
          <a class="menu-item" @click="goToPage('AboutPage')">{{
            $t("about")
          }}</a>
        </li>
      </ul>
    </div>
    <i class="iconfont icon-caidan menu-toggle" @click="toggleMobileMenu"></i>
    <div class="nav-box" :class="{ 'nav-box-show': isMobileMenuVisible }">
      <ul class="mobile-menu-list">
        <li>
          <a class="menu-item" @click="goToPage('HomePage')">{{
            $t("home")
          }}</a>
        </li>
        <li
          @click="toggleSubmenu('solutions')"
          :class="{ 'has-sub-menu': showSubmenu === 'solutions' }"
        >
          <a class="menu-item"
            >{{ $t("solutions") }}<i class="iconfont icon-xiala"></i
          ></a>
          <ul v-if="showSubmenu === 'solutions'" class="sub-menu">
            <li>
              <a class="sub-menu-item" @click="goToPage('SolutionPage1')">{{
                $t("solutionssub1")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('SolutionPage2')">{{
                $t("solutionssub2")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('SolutionPage3')">{{
                $t("solutionssub3")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('SolutionPage4')">{{
                $t("solutionssub4")
              }}</a>
            </li>
          </ul>
        </li>
        <li
          @click="toggleSubmenu('products')"
          :class="{ 'has-sub-menu': showSubmenu === 'products' }"
        >
          <a class="menu-item"
            >{{ $t("products") }}<i class="iconfont icon-xiala"></i
          ></a>
          <ul v-if="showSubmenu === 'products'" class="sub-menu">
            <li>
              <a class="sub-menu-item" @click="goToPage('ProductPage1')">{{
                $t("productssub1")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('ProductPage2')">{{
                $t("productssub2")
              }}</a>
              <a class="sub-menu-item" @click="goToPage('ProductPage3')">{{
                $t("productssub3")
              }}</a>
            </li>
          </ul>
        </li>
        <li>
          <a class="menu-item" @click="goToPage('SupportPage')">{{
            $t("support")
          }}</a>
        </li>
        <li>
          <a class="menu-item" @click="goToPage('NewsPage')">{{
            $t("news")
          }}</a>
        </li>
        <li>
          <a class="menu-item" @click="goToPage('AboutPage')">{{
            $t("about")
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuPage",
  data() {
    return {
      showSubmenu: null,
      isMobileMenuVisible: false,
    };
  },
  methods: {
    toggleSubmenu(menu) {
      if (this.showSubmenu === menu) {
        this.showSubmenu = null;
      } else {
        this.showSubmenu = menu;
      }
    },
    goToPage(pageName) {
      const currentRoute = this.$route.name;
      if (currentRoute !== pageName) {
        this.$router.push({ name: pageName });
      }
      this.isMobileMenuVisible = false; // 关闭手机端菜单
    },
    toggleMobileMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;
    },
  },
};
</script>

<style scoped>
.menu-main {
  float: left;
  width: 100%;
  padding: 0 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.logo-box {
  width: 200px;
  padding: 20px 0;
}

.logo-img {
  display: block;
  width: 150px;
  height: 84px;
}
.logo-img2 {
  display: none;
}

.menu-box {
  display: block;
}

.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}
.has-sub-menu {
  position: relative;
}

.menu-item {
  padding: 50px 20px;
  display: block;
  text-decoration: none;
  color: black;
  font-weight: 800;
  cursor: pointer;
  position: relative;
}

.sub-menu {
  position: absolute;
  top: 70px;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  list-style: none;
  z-index: 88;
}

.sub-menu li {
  width: 100%;
  cursor: pointer;
}

.sub-menu-item {
  color: #4a4a4a;
  padding: 10px 20px;
  display: block;
  text-decoration: none;
}

.sub-menu-item:hover {
  background-color: #f0f0f0;
}
.menu-toggle {
  display: none;
}
.nav-box {
  display: none;

  position: fixed;
  top: 100px;
  right: 0;
  width: 50%;

  z-index: 99;
  overflow-y: auto;
  border-radius: 5px 0 0 5px;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.nav-box-show {
  display: block;
}

.mobile-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.mobile-menu-list .menu-item {
  padding: 15px 20px;
  display: block;
  text-decoration: none;
  color: black;
  cursor: pointer;
  position: relative;
}

.mobile-menu-list .sub-menu {
  position: static;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  list-style: none;
  z-index: 88;
}

.mobile-menu-list .sub-menu li {
  width: 100%;
  cursor: pointer;
}

.mobile-menu-list .sub-menu-item {
  color: #4a4a4a;
  padding: 10px 30px;
  display: block;
  text-decoration: none;
}

.mobile-menu-list .sub-menu-item:hover {
  background-color: #f0f0f0;
}

/* 手机端样式调整 */
@media (max-width: 1200px) {
  .menu-toggle {
    display: block;
    color: #fff;
    padding: 10px;
    box-sizing: border-box;
    font-size: 40px;
  }
  .menu-main {
    float: left;
    width: 100%;
    padding: 0 10px;
    background: brown;
  }
  .menu-box {
    display: none;
  }
  .logo-box {
    width: 100px;
    padding: 10px 0;
  }

  .logo-img {
    display: none;
  }

  .logo-img2 {
    display: block;
    width: 80px;
    height: 45px;
  }
}
</style>